import React from "react";
import classes from "./PrivacyAware.scss";
import { connect } from "react-redux";
import classNames from "classnames";
class PrivateComponent extends React.PureComponent {
  render() {
    const { isScreen, isPrivate } = this.props;
    const containerClass = classNames(
      { [classes.container]: true },
      { [classes.screenContainer]: isScreen }
    );

    return isPrivate ? (
      <div data-private className={containerClass}>
        {this.props.children}
      </div>
    ) : (
      this.props.children
    );
  }
}

const mapActionCreators = {};

const mapStateToProps = (state, ownProps) => {
  return {
    isPrivate: false,
  };
};

export default connect(mapStateToProps, mapActionCreators)(PrivateComponent);
